import { inject as service } from '@ember/service';
import Component from '@glimmer/component';
import type IsOpenService from 'garaje/services/is-open';
import type StateService from 'garaje/services/state';

export default class DesksMenuComponent extends Component {
  @service declare isOpen: IsOpenService;
  @service declare state: StateService;
}
